import React from 'react';
import styled, { css } from 'styled-components';
import { STYLE_TYPE } from '@meettry/ui-components/constants';
import { COLOR_DEFINITIONS } from '@meettry/ui-components/styles/color';

type ValuesType = {
  value: number;
  content: string;
};

type SelectBoxType = {
  selectedValue: string;
  values: Array<ValuesType>;
  name?: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder: string;
  className?: string;
  size?: string;
  error?: boolean;
};

export const SelectBox: React.FC<SelectBoxType> = (props) => {
  const {
    selectedValue = '',
    values = [],
    name = '',
    onChange,
    placeholder = '',
    className,
    size = '',
    error = false
  } = props;

  return (
    <StyledSelectWrapper className={className} size={size}>
      <StyledSelect
        value={selectedValue}
        name={name}
        onChange={onChange}
        isDefault={'' === selectedValue}
        boxSize={size}
        error={error}
      >
        <StyledOption value="">{placeholder}</StyledOption>
        {values.map(({ value, content }) => (
          <StyledOption key={`${name}_${content}`} value={value}>
            {content}
          </StyledOption>
        ))}
      </StyledSelect>
    </StyledSelectWrapper>
  );
};

export default SelectBox;

const StyledSelectWrapper = styled.div<{ size: string }>`
  width: 100%;
  ${({ size }) => {
    switch (size) {
      case STYLE_TYPE.SIZE.LARGE:
      case STYLE_TYPE.SIZE.MEDIUM:
        return css`
          max-width: 200px;
        `;
      case STYLE_TYPE.SIZE.SMALL:
        return css`
          max-width: 140px;
        `;
      default:
        return null;
    }
  }}
  position: relative;
  ::after {
    content: '';
    width: 10px;
    height: 10px;
    display: block;
    position: absolute;
    top: 45%;
    right: 20px;
    transform: rotate(45deg) translate(-50%, -50%);
    border: 2px solid ${COLOR_DEFINITIONS.MAIN.PRIMARY};
    border-top: none;
    border-left: none;
  }
`;

const StyledSelect = styled.select<{ isDefault: boolean; boxSize: string; error: boolean }>`
  ${(props) => (props.isDefault ? `color: ${COLOR_DEFINITIONS.TEXT.SECONDARY}` : null)}
  -webkit-appearance: none;
  appearance: none;
  display: block;
  outline: none;
  border: 1px solid ${COLOR_DEFINITIONS.LINE.SECONDARY};
  border-radius: 4px;
  width: 100%;
  background-color: ${COLOR_DEFINITIONS.BG.SUB};
  padding: 0 20px;
  cursor: pointer;
  ${({ boxSize }) => {
    switch (boxSize) {
      case STYLE_TYPE.SIZE.LARGE:
      case STYLE_TYPE.SIZE.MEDIUM:
      case STYLE_TYPE.SIZE.SMALL:
        return css`
          font-size: 16px;
          height: 48px;
        `;
      default:
        return css`
          font-size: 12px;
          height: 40px;
        `;
    }
  }}
  ${({ error }) =>
    error
      ? css`
          background-color: ${COLOR_DEFINITIONS.BG.MODAL.MESSAGE};
          border: 1px solid ${COLOR_DEFINITIONS.TEXT.ALERT};
        `
      : null}
`;

const StyledOption = styled.option`
  line-height: 1;
  font-size: 16px;
`;
